
/* Firebase loader com múltiplos CDNs de fallback */
const _FBV='10.7.1';
const _FB_CDNS=[
  `https://www.gstatic.com/firebasejs/${_FBV}/firebase-app-compat.js`,
  `https://cdn.jsdelivr.net/npm/firebase@${_FBV}/firebase-app-compat.min.js`,
  `https://unpkg.com/firebase@${_FBV}/firebase-app-compat.js`,
];
const _FBF_CDNS=[
  `https://www.gstatic.com/firebasejs/${_FBV}/firebase-firestore-compat.js`,
  `https://cdn.jsdelivr.net/npm/firebase@${_FBV}/firebase-firestore-compat.min.js`,
  `https://unpkg.com/firebase@${_FBV}/firebase-firestore-compat.js`,
];
const _FBA_CDNS=[
  `https://www.gstatic.com/firebasejs/${_FBV}/firebase-auth-compat.js`,
  `https://cdn.jsdelivr.net/npm/firebase@${_FBV}/firebase-auth-compat.min.js`,
  `https://unpkg.com/firebase@${_FBV}/firebase-auth-compat.js`,
];
const _FBN_CDNS=[
  `https://www.gstatic.com/firebasejs/${_FBV}/firebase-functions-compat.js`,
  `https://cdn.jsdelivr.net/npm/firebase@${_FBV}/firebase-functions-compat.min.js`,
  `https://unpkg.com/firebase@${_FBV}/firebase-functions-compat.js`,
];
function _loadScript(src){
  return new Promise((res,rej)=>{
    const s=document.createElement('script');s.src=src;
    s.onload=res;s.onerror=rej;document.head.appendChild(s);
  });
}
window._firebaseReady=(async()=>{
  for(const url of _FB_CDNS){
    try{await _loadScript(url);break;}catch(e){console.warn('Firebase app CDN falhou:',url);}
  }
  if(typeof firebase==='undefined') return false;
  for(const url of _FBF_CDNS){
    try{await _loadScript(url);break;}catch(e){console.warn('Firebase firestore CDN falhou:',url);}
  }
  for(const url of _FBA_CDNS){
    try{await _loadScript(url);break;}catch(e){console.warn('Firebase auth CDN falhou:',url);}
  }
  for(const url of _FBN_CDNS){
    try{await _loadScript(url);break;}catch(e){console.warn('Firebase functions CDN falhou:',url);}
  }
  return typeof firebase!=='undefined'&&typeof firebase.firestore==='function';
})();
